import { connect } from 'react-redux';
import RegisterComponent from '../components/RegisterComponent';
import { registerUser } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
    firebasePopupOpen: state.profile.firebasePopupOpen,
});

const mapDispatchToProps = (dispatch) => ({
    registerUser: (data) => {
        dispatch(registerUser(data));
    },
});

const RegisterContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(RegisterComponent);

export default RegisterContainer;
